<template>
  <L1>
    <template slot="slot_title">
      <RadioTop :defaultValue="$route.query.page" @input="$router.replace({ name: $route.name, query: { page: $event } })"
      :options="['西售-盆栽銷售', '吧檯', '吉祥齋']"/>
    </template>
    <div id="kpisetting-body">
      <div>
        <div class="title1">POS機台設定 <RBtn :style="{marginLeft: 'auto'}" :bg="'var(--color-checked)'" :icon="'add'" :text="'新增機台'" @click="add=true"/></div>
        <div class="machines-list">
          <div class="machines" v-for="(machine, m) in machines" :key="m">
            <div>機台_{{machine}}</div>
            <button class="delbtn" @click="setMa(machine, false)"></button>
          </div>
        </div>
        <div class="title1">崗位設定</div>
        <div class="machines-list">
          <div class="machines" v-for="(group, m) in groups" :key="`group-${m}`">
            <div>{{group.group}}</div>
            <input type="text" :value="group.ratio" @change="setGp(group.group, $event)" class="numinput">
          </div>
        </div>
      </div>
      <div>
        <div class="title2">
          <div>銷售指標</div>
          <Select :width="'236px'" :defaultValue="sort" @input="sort=$event">
            <option :value="{createTime: -1}">新增時間排序 新>舊</option>
            <option :value="{createTime: 1}">新增時間排序 舊>新</option>
            <option :value="{id: 1}">商品貨邊排序 小>大</option>
            <option :value="{id: -1}">商品貨邊排序 大>小</option>
          </Select>
          <RBtn @click="areaupdate=area;editarea=true" :text="'選擇區域'" :bg="'var(--color-checked)'" :icon="'add'" :style="{marginLeft: 'auto'}"/>
        </div>
        <div  :style="{flex:1,overflowY: 'auto', maxHeight: 'calc(100vh - 169px)'}">
          <Table :rows="products">
            <template slot="slot_head">
              <th :style="{width: '180px', textAlign: 'start', paddingLeft: '48px'}">貨編</th>
              <th :style="{textAlign: 'start', width: 'inherit'}">品項</th>
              <th :style="{width: '200px', paddingRight: '66px'}">排除計算</th>
            </template>
            <tr slot-scope="item" :style="{borderBottom: '1px solid #CACACA'}">
              <td>{{item.item.id}}</td>
              <td :style="{textAlign: 'start'}">{{item.item.name}}</td>
              <td :style="{paddingTop: '10px', paddingRight: '66px'}" @click="setEx(item.item._id)">
                <div class="cross" :class="setExist(item.item._id)?'checked':''"></div>
              </td>
            </tr>
          </Table>
        </div>
      </div>
    </div>
    <dialogC :show="add" :width="517" :height="240" label="請選擇結算區間"
    @close="add=false">
    <div class="dbox">
      <input type="text" v-model="machineNum" placeholder="請輸入機台號碼">
      <button class="savebtn" :style="{
      }"
      @click="setMa(machineNum, true);machineNum=null;add=false">確認</button>
    </div>
    </dialogC>
    <dialogC :show="editarea" :width="760" :height="540" label="選擇區域"
    @close="editarea=false">
    <div class="dbox">
      <div class="area-ul">
        <input type="radio" class="area-li" v-for="(ar, a) in areas" :key="`areas-${a}`" v-model="areaupdate" :value="ar" :label="ar">
      </div>
      <Btns @save="setArea" @cancel="editarea=false"/>
    </div>
    </dialogC>
  </L1>
</template>

<script>
import Btns from '../../components/btn/btns.vue'
import Select from '../../components/select.vue'
import Table from '../../components/tables/t2.vue'
import dialogC from '../../components/dialog.vue'
import RBtn from '../../components/btn/round.vue'
import L1 from '../../components/layout/L1.vue'
import RadioTop from '../../components/radio/r1.vue'
import { postapi, getapi } from '../../store/fetch'
export default {
  components: {
    L1,
    RadioTop,
    RBtn,
    dialogC,
    Select,
    Table,
    Btns
  },
  data () {
    return {
      areas: ['吧檯', '松柏軒', '植栽', '票務', '內部用品', '全部商品'],
      editarea: false,
      add: false,
      machines: [],
      machineNum: null,
      sort: { createTime: -1 },
      products: [],
      area: null,
      areaupdate: null,
      groups: [],
      exclude: [],
      groupsdefault: []
    }
  },
  computed: {
    page () { return this.$route.query.page }
  },
  async mounted () {
    this.groupsdefault = await getapi('selections/cmcp_areas')
    await this.getdata()
  },
  watch: {
    async page () {
      await this.getdata()
    },
    sort: {
      async handler () {
        await this.getdata()
      },
      deep: true
    }
  },
  methods: {
    setExist (id) {
      return this.exclude.includes(id)
    },
    async setArea () {
      await postapi('cmcpAttendance/kpi/' + this.page, { area: this.areaupdate })
      await this.getdata()
      this.areaupdate = null
      this.editarea = false
    },
    async setGp (group, ev) {
      console.log('setGp', [group, ev.target.value, parseFloat(ev.target.value)])
      if (!ev.target.value) {
        const groups = await postapi('cmcpAttendance/kpi/groups/' + this.page, { act: 'unset', group })
        console.log('null => unset', groups)
        const g = Object.assign({}, ...groups.map(e => { return { [e.group]: e.ratio } }))
        console.log(g)
        this.groups = this.groupsdefault.map(e => { return { ratio: g[e], group: e } })
      } else if (ev.target.value !== null && !isNaN(parseFloat(ev.target.value))) {
        if (parseFloat(ev.target.value) > 1 || parseFloat(ev.target.value) < 0) {
          alert('數值必須介於0~1之間')
        } else {
          const groups = await postapi('cmcpAttendance/kpi/groups/' + this.page, { act: 'set', group, value: parseFloat(ev.target.value) })
          console.log('value => set', groups, parseFloat(ev.target.value))
          const g = Object.assign({}, ...groups.map(e => { return { [e.group]: e.ratio } }))
          console.log(g)
          this.groups = this.groupsdefault.map(e => { return { ratio: g[e], group: e } })
        }
      }
    },
    async setMa (num, bool) {
      console.log('setMa', num, bool ? 'set' : 'unset')
      const machines = await postapi('cmcpAttendance/kpi/machine/' + this.page, { act: bool ? 'set' : 'unset', num })
      console.log('machines', machines)
      this.machines = machines
    },
    async setEx (id) {
      console.log('SETEX')
      const bool = this.exclude.includes(id)
      const exclude = await postapi('cmcpAttendance/kpi/exclude/' + this.page, { act: bool ? 'unset' : 'set', id })
      console.log('exclude', exclude)
      this.exclude = exclude
    },
    async getdata () {
      const { machines, products, area, groups, exclude } = await getapi('cmcpAttendance/kpi/' + this.page + '?' + new URLSearchParams({ sort: Object.keys(this.sort)[0], asc: Object.values(this.sort)[0] }))
      this.machines = [...machines]
      this.products = products
      this.area = area
      const g = Object.assign({}, ...groups.map(e => { return { [e.group]: e.ratio } }))
      console.log(g)
      this.groups = this.groupsdefault.map(e => { return { ratio: g[e], group: e } })
      this.exclude = exclude
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.numinput {
  height: 40px;
  width: 60px;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #6D6D6D;
  border: 1px solid #CACACA;
  border-radius: 3px;
}
.area-ul {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.area-li {
  border-radius: 3px;
  width: 190px;
  height: 60px;
  color: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  background-color: #B8B8B8;
  appearance: none;
  &:checked {
    background-color: var(--color-checked);
  }
  &::before {
    content: attr(label);
  }
}
.cross {
  margin: auto;
  display: flex;
  width: 30px;
  height: 30px;
  background-color: #E6E6E6;
  mask-image: url(/svg/checkbox/cross.svg);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 30px;
  &.checked {
    background-color: #E37878;
  }
}
.title2 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 76px;
  padding: 0 48px;
  gap: 1em;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;

}
.delbtn {
  mask-image: url(/svg/btn/del.svg);
  width: 30px;
  height: 30px;
  background-color: #E37878;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 23px;
}
.machines-list {
  flex:1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 28px;
  gap: 15px;
  overflow-y: auto;
  max-height: calc(100vh - 190px);
  padding-bottom: 20px;
}
.machines {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */
  border-radius: 3px;
  letter-spacing: 0.1em;
  border: 1px solid var(--color-checked);
  padding: 17px 20px;
  color: var(--color-checked);
}
.dbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  input[type=text] {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.1em;
    width: 350px;
    height: 45px;
    border: 1px solid #848484;
    border-radius: 3px;
    &::placeholder {
      color: #C4C4C4;
    }

  }
}
.cancelbtn {
  background-color: #B8B8B8;
  width: 100px;
  height: 35px;
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  border: none;
  margin-inline: auto;
}
.savebtn {
  background-color: #E37878;
  width: 100px;
  height: 35px;
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  border: none;
  margin-inline: auto;
}
#kpisetting-body {
  display: grid;
  grid-template-columns: 400px 1fr;
  flex:1;
  height: -webkit-fill-available;
  overflow-y: hidden;
  &>div{
    flex: 1;
    height: -webkit-fill-available;
    overflow-y: auto;
    &:nth-child(1) {
      border-right: 1px solid #CACACA;
      padding: 21px 17px 0 43px;
      &>div:nth-child(2) {
        padding-right: 23px;
      }
    }
  }
  .title1 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: -webkit-fill-available;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
  }
}
</style>
